import moment from 'moment';
import styles from '../../../../styles/Admin.module.scss';

const TYPE_LABELS = {
    cit_first: 'First payment',
    mit_subsequent: 'Recurring',
    one_time: 'One-time',
    subscription: 'Subscription'
};

const STATUS_CLASS = {
    authorized: styles.active,
    settled: styles.active,
    active: styles.active,
    refused: styles.pastDue,
    error: styles.pastDue,
    past_due: styles.pastDue,
    cancelled: null,
    paused: null
};

function Item({ date, firstName, lastName, email, plan, amount, status, type, nextBillingDate, paymentCount }) {
    return (
        <tr>
            <td>{moment(date).format('DD MMM YYYY, HH:mm')}</td>
            <td>{firstName || lastName ? `${firstName} ${lastName}`.trim() : '—'}<br /><small style={{ opacity: 0.6 }}>{email}</small></td>
            <td>{plan || '—'}</td>
            <td>£{amount ? (amount / 100).toFixed(2) : '0.00'}</td>
            <td>{TYPE_LABELS[type] || type || '—'}</td>
            <td>
                <span className={`${styles.membershipInfo} ${STATUS_CLASS[status] || ''}`}>
                    {status}
                </span>
            </td>
            <td>{nextBillingDate ? moment(nextBillingDate).format('DD MMM YYYY') : paymentCount != null ? `${paymentCount} payment${paymentCount !== 1 ? 's' : ''}` : '—'}</td>
        </tr>
    );
}

export default Item;
